import {BasicCriteria} from '../../../allkey/framework/parameters/BasicCriteria';

export class VisionKeyCriteria extends BasicCriteria {
chronoCode: string;
visionCode: string;
}

